export type EdullaConfig = {
    LogoUrl: string
    SquareLogoUrl: string
    SmallHeaderLogoUrl: string
    HeaderBackgroundImageHome: string
    PrimaryColor: string
    SecondaryColor: string
    TertiaryColor: string
    TextInputBackground: string
    BoxShadow: string
    BorderRadiusNumber: number
    Gap: string
    PaddingNumber: number
    Border: string
    FontFamily: string
    TransparentBackground: string
    ButtonBackground: string
    MuiFilledInputBackground: string
    HomeHeadline1: string
    HomeHeadline2: string
    HomeHeadline3: string
    HomeAskAQuestionHeadline1: string
    HomeAskAQuestionHeadline2: string
    IndexName: string
    HomeSearchHeadline1: string
    HomeSearchHeadline2: string
    OpenByDefault?: boolean
    PromptBubbleMessage?: string
    PromptBubbleShowOnDesktop?: boolean
    PromptBubbleShowOnMobile?: boolean
}

export const configInitial: EdullaConfig = {
    LogoUrl: "",
    SquareLogoUrl: "",
    SmallHeaderLogoUrl: "",
    HeaderBackgroundImageHome: "",
    PrimaryColor: "",
    SecondaryColor: "",
    TertiaryColor: "",
    TextInputBackground: "",
    BoxShadow: "",
    BorderRadiusNumber: 0,
    Gap: "",
    PaddingNumber: 0,
    Border: "",
    FontFamily: "",
    TransparentBackground: "",
    ButtonBackground: "",
    MuiFilledInputBackground: "",
    HomeHeadline1: "",
    HomeHeadline2: "",
    HomeHeadline3: "",
    HomeAskAQuestionHeadline1: "",
    HomeAskAQuestionHeadline2: "",
    IndexName: "",
    HomeSearchHeadline1: "",
    HomeSearchHeadline2: "",
    OpenByDefault: false,
    PromptBubbleMessage: "Hello! Is there anything I can help you with today?",
    PromptBubbleShowOnDesktop: true,
    PromptBubbleShowOnMobile: true
}
